import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Preferences from "../views/Preferences.vue";
import WaterTank from "../views/WaterTank.vue";
import Gauges from "../views/Gauges.vue";

// Device Manager
import Index from "../views/Devices/Index.vue";
import Devices from "../views/Devices/Devices.vue";

// Auth
import Login from "../components/auth/Login.vue";
import Register from "../components/auth/Register.vue";
import firebase from "firebase";

// Test
import Test from "../views/TestPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/preferences",
    name: "Preferences",
    component: Preferences,
    meta: {
      auth: true,
    },
  },
  {
    path: "/watertank",
    name: "WaterTank",
    component: WaterTank,
    meta: {
      auth: true,
    },
  },
  {
    path: "/gauges",
    name: "Gauges",
    component: Gauges,
    meta: {
      auth: true,
    },
  },
  {
    path: "/devices",
    component: Index,
    props: true,
    meta: {
      auth: true,
    },
    children: [
      {
        path: "", //selected tab by default
        component: Devices,
      },
    ],
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
    meta: {
      auth: true,
    },
  },
  // },
  // { path: '/heating',
  //   component: Heating,
  //   meta: {
  //     auth: true
  //   },
  //   children: [
  //     {
  //       path: '',
  //       component: WaterTank
  //     },
  //     {
  //       path: 'devices',
  //       component: BufferTank
  //     }
  //   ]
  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      guest: true,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      guest: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next();
      } else {
        next({
          path: "/login",
        });
      }
    });
  } else if (to.matched.some((record) => record.meta.guest)) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next({
          path: "/",
        });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
